// CardConsulta.tsx

import { Link } from 'react-router-dom';
import { CarLicencePlates } from './CarLicencePlates';

// Assuming Placas is a separate component
// import Placas from './Placas';

export const SearchSection = () => {
    return (
        <div className=" bg-[#f4f5f5] p-8 lg:p-12 ">
            <div className=" bg-white p-8 rounded-2xl shadow-lg">
                <div className="mb-8">
                    <h2 className="text-2xl md:text-3xl font-bold font-roboto text-black">
                        Consulta y Pago de Infracciones
                    </h2>
                    <p className="text-lg font-roboto text-gray-500 mt-2">
                        Para consultar tus multas de tránsito, teclea tu placa sin guiones ni espacios
                    </p>
                </div>

                <CarLicencePlates />

                <div className="mt-8 pt-8">
                    <p className="text-base md:text-lg font-roboto text-gray-500 mt-2">
                        Para dudas sobre su adeudo llámenos al 81 8305 0900, Ext. 1978
                    </p>

                    <Link
                        to="/aviso-privacidad"
                        className="block text-center text-base md:text-lg font-roboto text-yellow-400 mt-4 hover:text-yellow-500 transition-colors"
                    >
                        Aviso de privacidad
                    </Link>
                </div>
            </div>
        </div>
    );
};
